import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Lookup from '@/api/lookup/api-lookup';
import { Delete, Get, Put, Post } from '@/api/api-middleware';
import { getCompanyID, getEmployeeID } from '@/helpers/Utils';
import { firstListItem ,itemPerPage} from '@/constants/defaultValues';
import { apiPath } from '@/constants/defaultValues';

const initialState = {
  loading: false,
  AddUpdateDeleteResponse : [],
  ActionsList : [],
  WorkScheduleList : [],
  notification :{show : false, code : ""},
  WorkScheduleItem : {},
  error: '',
};

export const AddAction = createAsyncThunk('recalculate/AddAction',
  async (params, thunkAPI) => {
    try {
      const response = await Post({
        url: `${apiPath}${'api/Operations/Actions/AddAction'}`,
        data:params,
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const fetchAllActions = createAsyncThunk('recalculate/fetchAllActions',
  async (params, thunkAPI) => {
    try {
      const response = await Post({
        url: `${apiPath}${'api/Operations/Actions/GetAction'}`,
        data: params,
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const getWorkScheduleById = createAsyncThunk('workSchedule/getWorkScheduleById',
  async (params, thunkAPI) => {
    try {
      const response = await Get({ url: `${apiPath}api/Lookup/WorkSchedule/GetByID/${params}` });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const updateManualEntry = createAsyncThunk('manualEntry/updateManualEntry',
  async (params, thunkAPI) => {
    try {
      const response = await Put({
        url: `${apiPath}${'api/Operations/ManualEntry/Update'}`,
        data:params,
      });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

export const deleteManualEntry = createAsyncThunk('manualEntry/deleteManualEntry',
  async (params, thunkAPI) => {
    try {
      const response = await Delete({ url: `${apiPath}api/Operations/ManualEntry/Delete/${params.id}/${params.companyID}` });
      return response?.data?.data;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message);
    }
  }
);

const recalculateSlice = createSlice({
  name: 'recalculate',
  initialState,
  reducers: {
    clearCurrentItem: (state) => { 
      state.AddWorkScheduleResponse = [];
      state.PaginatedWorkScheduleResponse = [];
      state.WorkScheduleItem = {};
     },
  },
  extraReducers: (builder) => {

    builder.addCase(AddAction.pending, (state) => {
      state.loading = true;
      state.notification = {show : false, code : ""};
    })
    .addCase(AddAction.fulfilled, (state, action) => {
      state.loading = false;
      state.AddUpdateDeleteResponse = action.payload;
      state.notification = {show : true, code : "200"};
      state.error = '';
    })
    .addCase(AddAction.rejected, (state, action) => {
      state.loading = false;
      state.AddUpdateDeleteResponse = [];
      state.error = action.payload ?? 'An error occurred';
    });

    builder.addCase(fetchAllActions.pending, (state) => {
      state.loading = true;
      state.notification = {show : false, code : ""};
      state.ActionsList = [];
    })
    .addCase(fetchAllActions.fulfilled, (state, action) => {
      state.loading = false;
      state.ActionsList = action.payload;
      state.error = '';
    })
    .addCase(fetchAllActions.rejected, (state, action) => {
      state.loading = false;
      state.ActionsList = [];
      state.error = action.payload ?? 'An error occurred';
    });
     
    builder.addCase(getWorkScheduleById.pending, (state) => {
      state.loading = true;
      state.notification = {show : false, code : ""};
    })
    .addCase(getWorkScheduleById.fulfilled, (state, action) => {
      state.loading = false;
      state.WorkScheduleItem = action.payload;
      state.error = '';
    })
    .addCase(getWorkScheduleById.rejected, (state, action) => {
      state.loading = false;
      state.WorkScheduleItem = {};
      state.error = action.payload ?? 'An error occurred';
    });

    builder.addCase(updateManualEntry.pending, (state) => {
      state.loading = true;
      state.notification = {show : false, code : ""};
    })
    .addCase(updateManualEntry.fulfilled, (state, action) => {
      state.loading = false;
      state.AddUpdateDeleteResponse = action.payload;
      state.notification = {show : true, code : "200"};
      state.error = '';
    })
    .addCase(updateManualEntry.rejected, (state, action) => {
      state.loading = false;
      state.AddUpdateDeleteResponse = [];
      state.error = action.payload ?? 'An error occurred';
    });

    builder.addCase(deleteManualEntry.pending, (state) => {
      state.loading = true;
      state.AddUpdateDeleteResponse = [];
      state.notification = {show : false, code : ""};
    })
    .addCase(deleteManualEntry.fulfilled, (state, action) => {
      state.loading = false;
      state.AddUpdateDeleteResponse = action.payload;
      state.notification = {show : true, code : "200"};
      state.error = '';
    })
    .addCase(deleteManualEntry.rejected, (state, action) => {
      state.loading = false;
      state.AddUpdateDeleteResponse = [];
      state.error = action.payload ?? 'An error occurred';
    });

  },
});

export const { clearCurrentItem } = recalculateSlice.actions;
export default recalculateSlice.reducer;
